import { Link } from "react-router-dom";
//import useDownloader from 'react-use-downloader'

const Monoperc = ({param}) => {
    /*
    const { download } = useDownloader(); 
    const prodDownloadBtnClick = () => {
        const pdfUrl = "images/junna_solar.pdf";
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "document.pdf"; // specify the filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }; 
    */
    return (
        <div className="text-center">                       
            <div className="Products">
                <img src={param.image} alt={param.name}/>  
                <h4 className="heading">{param.name}</h4>
                <p className="blue">{param.description}</p>
                <Link 
                    className="download1" 
                    to={param.datasheet_link} 
                    target="_blank"
                    //onClick={prodDownloadBtnClick}
                    //onClick={()=>download(param.datasheet_link, 'datasheet.pdf')}
                    >Download datasheet
                </Link>
            </div>                            
        </div>
    )
}

export default Monoperc